import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = { class: "left-content" }
const _hoisted_3 = { class: "bold-text" }
const _hoisted_4 = { class: "orderCmd" }
const _hoisted_5 = { class: "polyline-cards" }
const _hoisted_6 = { class: "block" }

import useI18nTl from '@/hooks/useI18nTl'
import { Refresh } from '@element-plus/icons-vue'
import { getOrderSampling } from '@/api/operation'
import TrendChart from '@/components/TrendChart.vue'
import { ref } from 'vue'

type ChartData = {
  xData: Array<number>
  yData: Array<number>
}
type ChartDatas = Array<ChartData>


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'OrderDetailMonitor',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  orderId: {
    type: String,
    required: true,
    default: '0',
  },
},
  setup(__props) {

const props = __props

const { t } = useI18nTl('Order')



const chartDataFill = (length: number): ChartDatas => {
  return Array.from({ length }, () => ({ xData: [], yData: [] }))
}

const isLoading = ref(false)
const currentChartId = ref('order-current-trend-polyline')
const currentChartDatas = ref<ChartDatas>(chartDataFill(1))
const currentChartTitle = ref(t('Evses.currentA'))

const powerChartId = ref('order-power-trend-polyline')
const powerChartDatas = ref<ChartDatas>(chartDataFill(1))
const powerChartTitle = ref(t('Evses.powerW'))

const chargingElecChartId = ref('order-elec-trend-polyline')
const chargingElecChartDatas = ref<ChartDatas>(chartDataFill(1))
const chargingElecChartTitle = ref(t('Evses.electricityKhw'))

const chargingCostChartId = ref('order-cost-trend-polyline')
const chargingCostChartDatas = ref<ChartDatas>(chartDataFill(1))
const chargingCostChartTitle = ref(t('Order.orderAmount'))

const loadChartMetrics = async () => {
  try {
    isLoading.value = true

    const data = await getOrderSampling(props.orderId)
    data.samplings.forEach((item: any) => {
      currentChartDatas.value[0].xData.push(item.samplingTime * 1000)
      currentChartDatas.value[0].yData.push(item.currentA)
      powerChartDatas.value[0].xData.push(item.samplingTime * 1000)
      powerChartDatas.value[0].yData.push(item.power)

      chargingElecChartDatas.value[0].xData.push(item.samplingTime * 1000)
      chargingElecChartDatas.value[0].yData.push(item.totalElec)
      chargingCostChartDatas.value[0].xData.push(item.samplingTime * 1000)
      chargingCostChartDatas.value[0].yData.push(item.totalCost)
    })
  } catch (error) {
    console.log('error: ', error)
  } finally {
    isLoading.value = false
  }
}

const getLineColors = (index: number) => {
  const totalColors = ['#3D7FF9', '#5D4EFF', '#757789', '#00A890', '#F49845', '#66CFDA']
  const changedColorArr = [...totalColors.splice(0, 1, totalColors[index])]
  totalColors.splice(index, 1, changedColorArr[0])
  return totalColors
}

loadChartMetrics()

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { class: "card-spacing" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('Order.meterValueSampling')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            class: "icon-button",
            plain: "",
            size: "small",
            type: "primary",
            icon: _unref(Refresh),
            onClick: loadChartMetrics
          }, null, 8, ["icon"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_row, { gutter: 26 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  (!isLoading.value)
                    ? (_openBlock(), _createBlock(TrendChart, {
                        key: 0,
                        "chart-id": currentChartId.value,
                        "chart-data": currentChartDatas.value,
                        "y-title": [currentChartTitle.value],
                        chartColors: getLineColors(1)
                      }, null, 8, ["chart-id", "chart-data", "y-title", "chartColors"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  (!isLoading.value)
                    ? (_openBlock(), _createBlock(TrendChart, {
                        key: 0,
                        "chart-id": powerChartId.value,
                        "chart-data": powerChartDatas.value,
                        "y-title": [powerChartTitle.value],
                        chartColors: getLineColors(1)
                      }, null, 8, ["chart-id", "chart-data", "y-title", "chartColors"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  (!isLoading.value)
                    ? (_openBlock(), _createBlock(TrendChart, {
                        key: 0,
                        "chart-id": chargingElecChartId.value,
                        "chart-data": chargingElecChartDatas.value,
                        "y-title": [chargingElecChartTitle.value],
                        chartColors: getLineColors(1)
                      }, null, 8, ["chart-id", "chart-data", "y-title", "chartColors"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  (!isLoading.value)
                    ? (_openBlock(), _createBlock(TrendChart, {
                        key: 0,
                        "chart-id": chargingCostChartId.value,
                        "chart-data": chargingCostChartDatas.value,
                        "y-title": [chargingCostChartTitle.value],
                        chartColors: getLineColors(1)
                      }, null, 8, ["chart-id", "chart-data", "y-title", "chartColors"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})